import { createSelector } from '@reduxjs/toolkit';

import type { PropsCoreState } from '~/store/interfaces';

export const selectNotifications = ({ notifications }: PropsCoreState) => notifications;
export const selectUnreadCount = createSelector(
  [selectNotifications],
  (n) => n.items.filter((i) => !i.read).length,
);
